module.exports = __webpack_public_path__ + "static/media/export.163c1aaa.csv";